const API_PATH = {
    poster: {
        getPosterCategoryLists: process.env.DOMAIN + '/poster/category/page/list',
        getPosterCategoryListsNoPagination: process.env.DOMAIN + '/poster/category/list',
        togglePosterCategoryStatus: process.env.DOMAIN + '/poster/category/toggle/status',
        deletePosterCategory: process.env.DOMAIN + '/poster/category/delete',
        addPosterCategory: process.env.DOMAIN + '/poster/category/create',
        editPosterCategory: process.env.DOMAIN + '/poster/category/update',
        getPosterCategoryInfo: process.env.DOMAIN + '/poster/category/detail',
        getPoster: process.env.DOMAIN + '/poster/list',
        deletePoster: process.env.DOMAIN + '/poster/delete',
        showPoster: process.env.DOMAIN + '/poster/toggle/show',
        recommendPoster: process.env.DOMAIN + '/poster/toggle/recommend',
        stickPoster: process.env.DOMAIN + '/poster/toggle/top',
        addPoster: process.env.DOMAIN + '/poster/create',
        getPosterInfo: process.env.DOMAIN + '/poster/detail',
        editPoster: process.env.DOMAIN + '/poster/update'
    },

    video: {
        getVideoCategoryLists: process.env.DOMAIN + '/video/category/page/list',
        getVideoCategoryListsNoPagination: process.env.DOMAIN + '/video/category/list',
        addVideoCategory: process.env.DOMAIN + '/video/category/create',
        editVideoCategory: process.env.DOMAIN + '/video/category/update',
        deleteVideoCategory: process.env.DOMAIN + '/video/category/delete',
        toggleVideoCategoryStatus: process.env.DOMAIN + '/video/category/toggle/status',
        getVideoCategoryInfo: process.env.DOMAIN + '/video/category/detail',
        getVideoLists: process.env.DOMAIN + '/video/list',
        showVideo: process.env.DOMAIN + '/video/toggle/show',
        editVideo: process.env.DOMAIN + '/video/update',
        recommendVideo: process.env.DOMAIN + '/video/toggle/recommend',
        stickVideo: process.env.DOMAIN + '/video/toggle/top',
        getVideoInfo: process.env.DOMAIN + '/video/detail',
        addVideo: process.env.DOMAIN + '/video/create',
        deleteVideo: process.env.DOMAIN + '/video/delete'
    },

    platformGuide: {
        getPlatformGuideList: process.env.DOMAIN + '/supplier/platform_guide/list-with-page',
        addPlatformGuide: process.env.DOMAIN + '/supplier/platform_guide/create',
        salePlatformList: process.env.DOMAIN + '/supplier/platform_guide/sale-platform-list',
        contentSalePlatformList: process.env.DOMAIN + '/supplier/platform_guide/belong-channel-list',
        platformGuideShow: process.env.DOMAIN + '/supplier/platform_guide/show',
        platformGuideUpdate: process.env.DOMAIN + '/supplier/platform_guide/update',
        getGuideList: process.env.DOMAIN + '/supplier/platform_guide/guide-list',
        checkGuideContent: process.env.DOMAIN + '/supplier/platform_guide/check-guide-content',
        getGuideProductInsuarnce: process.env.DOMAIN + '/product/insurance-class',
        getGuiApiCps: process.env.DOMAIN + '/product/api_cps_products',
        guideExport: process.env.DOMAIN + '/supplier/platform_guide/export',
    },

    article: {
        getArticleCategoryLists: process.env.DOMAIN + '/article/category/page/list',
        getVideoCategoryListsNoPagination: process.env.DOMAIN + '/article/category/list',
        toggleArticleCategoryStatus: process.env.DOMAIN + '/article/category/toggle/status',
        deleteArticleCategory: process.env.DOMAIN + '/article/category/delete',
        addArticleCategory: process.env.DOMAIN + '/article/category/create',
        getArticleCategoryInfo: process.env.DOMAIN + '/article/category/detail',
        editArticleCategory: process.env.DOMAIN + '/article/category/update',
        getArticleTagsLists: process.env.DOMAIN + '/article/tag/page/list',
        getArticleTagsListsNoPagination: process.env.DOMAIN + '/article/tag/list',
        deleteArticleTag: process.env.DOMAIN + '/article/tag/delete',
        addArticledTag: process.env.DOMAIN + '/article/tag/create',
        getArticleLists: process.env.DOMAIN + '/article/list',
        stickArticle: process.env.DOMAIN + '/article/toggle/top',
        recommendArticle: process.env.DOMAIN + '/article/toggle/recommend',
        deleteArticle: process.env.DOMAIN + '/article/delete',
        showArticle: process.env.DOMAIN + '/article/toggle/show',
        getArticleInfo: process.env.DOMAIN + '/article/detail',
        addArticle: process.env.DOMAIN + '/article/create',
        editArticle: process.env.DOMAIN + '/article/update',
        getArticleChannelLists: process.env.DOMAIN + '/article/channel/list',
        getDraftsList: process.env.DOMAIN + '/article/draft/page/list',
        getSceneOptions: process.env.DOMAIN + '/article/draft/scene-options',
        draftDelete: process.env.DOMAIN + '/article/draft/delete',
        manyDelete: process.env.DOMAIN + '/article/draft/many-delete',
        articleCopy: process.env.DOMAIN + '/article/copy',
        generationLink: process.env.DOMAIN + '/article/draft/preview/generation-link',
        draftSave: process.env.DOMAIN + '/article/draft/save',
        draftAutoSave: process.env.DOMAIN + '/article/draft/auto/save'
    },

    question: {
        getQuestionList: process.env.DOMAIN + '/question/info/list',
        addQuestion: process.env.DOMAIN + '/question/info/add',
        delQuestion: process.env.DOMAIN + '/question/info/del',
        getTagsSelect: process.env.DOMAIN + '/question/info/tags',
        getQuestionDetail: process.env.DOMAIN + '/question/info/show',
        updateQuestion: process.env.DOMAIN + '/question/info/update',
        getTagList: process.env.DOMAIN + '/question/tag/list',
        delTag: process.env.DOMAIN + '/question/tag/del',
        addTag: process.env.DOMAIN + '/question/tag/add'
    },

    member: {
        getMemberLists: process.env.DOMAIN + '/admin/list',
        getMemberInfo: process.env.DOMAIN + '/admin/detail',
        editMember: process.env.DOMAIN + '/admin/update',
        addMember: process.env.DOMAIN + '/admin/create'
    },

    publicApi: {
        login: process.env.DOMAIN + '/auth/login',
        logout: process.env.DOMAIN + '/auth/logout',
        modifyPassword: process.env.DOMAIN + '/admin/reset/password'
    },

    role: {
        getRolePermissionLists: process.env.DOMAIN + '/permission/all',
        getRoleListsNoPagination: process.env.DOMAIN + '/role/list',
        getRoleLists: process.env.DOMAIN + '/role/page/list',
        deleteRole: process.env.DOMAIN + '/role/delete',
        getRoleInfo: process.env.DOMAIN + '/role/detail',
        editRole: process.env.DOMAIN + '/role/update',
        addRole: process.env.DOMAIN + '/role/create'
    },
    upload: {
        uploadFuture: process.env.UPLOAD_DOMAIN + '/api/images/upload',

        uploadFile: process.env.UPLOAD_FILE_DOMAIN + '/api/files/upload'
    },

    cps: {
        checkCPSAlias: process.env.DOMAIN + '/cps/product/check/alias',
        checkAPIAlias: process.env.DOMAIN + '/product/core/check/alias',
        getCPSList: process.env.DOMAIN + '/cps/product/page/list',
        getUploadInfo: process.env.DOMAIN + '/product/common-terms/list',
        uploadMateral: process.env.DOMAIN + '/product/common-terms/save',
        changeStatus: process.env.DOMAIN + '/cps/product/change/status',
        add: process.env.DOMAIN + '/cps/product/store',
        edit: process.env.DOMAIN + '/cps/product/update',
        getCPSDetail: process.env.DOMAIN + '/cps/product/show',
        getCPSLinkList: process.env.DOMAIN + '/cps/link/list',
        uploadExcel: process.env.DOMAIN + '/cps/product/import/link',
        getProductCoreList: process.env.DOMAIN + '/product/core/page/list',
        addProductCore: process.env.DOMAIN + '/product/core/store',
        getProductDetail: process.env.DOMAIN + '/product/core/show',
        updateProduct: process.env.DOMAIN + '/product/core/update',
        getPlanList: process.env.DOMAIN + '/cps/coefficient/plan/page/list',
        getCorePlanList: process.env.DOMAIN + '/product/coefficient/plan/page/list',
        deletePlan: process.env.DOMAIN + '/cps/coefficient/plan/del',
        deleteCorePlan: process.env.DOMAIN + '/product/coefficient/plan/del',
        getCpsInfo: process.env.DOMAIN + '/cps/product/product',
        getProgramLists: process.env.DOMAIN + '/cps/product/program/list',
        getCoreProgramLists: process.env.DOMAIN + '/product/core/program/list',
        getIrTypeLists: process.env.DOMAIN + '/cps/product/insurance/type/list',
        addCoefficientPlan: process.env.DOMAIN + '/cps/coefficient/plan/store',
        copyCoefficientPlan: process.env.DOMAIN + '/cps/coefficient/plan/copy',
        addCoreCoefficientPlan: process.env.DOMAIN + '/product/coefficient/plan/store',
        copyCoreCoefficientPlan: process.env.DOMAIN + '/product/coefficient/plan/copy',
        getPlanInfo: process.env.DOMAIN + '/cps/coefficient/plan/show',
        getCorePlanInfo: process.env.DOMAIN + '/product/coefficient/plan/show',
        updatePlanInfo: process.env.DOMAIN + '/cps/coefficient/plan/update',
        updateCorePlanInfo: process.env.DOMAIN + '/product/coefficient/plan/update',
        getCoreProdInfo: process.env.DOMAIN + '/product/core/product',
        cpsBatchUploadExcel: process.env.DOMAIN + '/cps/product/import/many/link',
        cpsBatchUploadInsuranceTypeExcel: process.env.DOMAIN + '/cps/product/import/insurance/excel',
        cpsBatchUploadParamExcel: process.env.DOMAIN + '/cps/product/import/params/excel',
        cpsBatchUploadByQX: process.env.DOMAIN + '/cps/product/import/qixin/link',
        cpsBatchUploadByZA: process.env.DOMAIN + '/cps/product/import/zhongan/link',
        getKeyWordLists: process.env.DOMAIN + '/cps/product/keyword/list',
        getCoreKeyWordLists: process.env.DOMAIN + '/product/core/keyword/list',
        getApiProductCoreRateTypeList: process.env.DOMAIN + '/product/core/rate/type/list',
        getApiProductBaseInfo: process.env.DOMAIN + '/product/core/show/base_info',
        getApiProductParamsInfo: process.env.DOMAIN + '/product/core/show/attribute',
        getApiProductInsurance: process.env.DOMAIN + '/product/core/show/insurance',
        editApiProductBaseInfo: process.env.DOMAIN + '/product/core/update/base_info',
        editApiProductParamsInfo: process.env.DOMAIN + '/product/core/update/attribute',
        editApiProductInsuranceInfo: process.env.DOMAIN + '/product/core/update/insurance',
        underwriteRulesUpload: process.env.DOMAIN + '/underwrite-rule/upload-file',
        customeriteRulesUpload: process.env.DOMAIN + '/customer-service/upload-file',
        claimSettlementUpload: process.env.DOMAIN + '/claim-settlement/upload-file',
        underwriteRulesRecode: process.env.DOMAIN + '/underwrite-rule/file-log-list',
        customerLogList: process.env.DOMAIN + '/customer-service/file-log-list',
        claimSettlementRulesRecode: process.env.DOMAIN + '/claim-settlement/file-log-list',
        underwriteRulesList: process.env.DOMAIN + '/underwrite-rule/rule-list',
        deleteUnderwriteRule: process.env.DOMAIN + '/underwrite-rule/delete-rule',
        uploadFile: process.env.DOMAIN + '/health_notice/upload/file',
        insuranceRulesList: process.env.DOMAIN + '/underwrite-rule/insurance/rule-list',
        customerServiceList: process.env.DOMAIN + '/customer-service/customer-service-list',
        // 售后指引列表
        salesGuidelinesList: process.env.DOMAIN + '/product-sales-guidance/list',
        // 售后指引上传文件记录
        salesGuidelinesLogList: process.env.DOMAIN + '/product-sales-guidance/file-log-list',
        // 售后指引文件上传
        salesGuidelinesUpload: process.env.DOMAIN + '/product-sales-guidance/upload-file',
        // 售后指引删除
        deleteSalesGuidelines: process.env.DOMAIN + '/product-sales-guidance/delete',
        // 售后指引获取显示字段
        showSalesGuidelinesColumns: process.env.DOMAIN + '/product-sales-guidance/show_columns',
        // 售后指引设置显示字段
        setSalesGuidelinesColumns: process.env.DOMAIN + '/product-sales-guidance/set/show_columns',
        claimSettlementList: process.env.DOMAIN + '/claim-settlement/claim-settlement-list',
        deleteInsuranceRule: process.env.DOMAIN + '/underwrite-rule/insurance/delete-rule',
        deleteCustomerService: process.env.DOMAIN + '/customer-service/delete-customer-service',
        deleteClaimSettlement: process.env.DOMAIN + '/claim-settlement/delete-claim-settlement',
        getHealthNoticeDetail: process.env.DOMAIN + '/health_notice/detail',
        getUnderwritingDetail: process.env.DOMAIN + '/health_notice/underwriting/detail',
        getUnderwritingUploadRecord: process.env.DOMAIN + '/health_notice/underwriting/file_log/list',
        getHealthNoticeUploadRecord: process.env.DOMAIN + '/health_notice/file_log/list',
        getUnderwritingProductList: process.env.DOMAIN + '/health_notice/underwriting/product_name/list',
        getHealthNoticeProductList: process.env.DOMAIN + '/health_notice/product_name/list',
        removeHealthNoticeProduct: process.env.DOMAIN + '/health_notice/deleteById',
        removeUnderwritingProduct: process.env.DOMAIN + '/health_notice/underwriting/deleteById',
        getUnderwriteRuleList: process.env.DOMAIN + '/health_notice/underwrite-rule/list',
        getUnderwriteRuleDetail: process.env.DOMAIN + '/health_notice/underwrite-rule/detail',
        getQuestionTagList: process.env.DOMAIN + '/question/tag/list',
        addQuestionTag: process.env.DOMAIN + '/question/tag/add',
        removeQuestionTag: process.env.DOMAIN + '/question/tag/del',
        getQuestionContentList: process.env.DOMAIN + '/question/info/page/list',
        removeQuestionContent: process.env.DOMAIN + '/question/info/del',
        addQuestionContent: process.env.DOMAIN + '/question/info/add',
        editQuestionContent: process.env.DOMAIN + '/question/info/update',
        getQuestionContentTagList: process.env.DOMAIN + '/question/info/tags',
        getQuestionDetail: process.env.DOMAIN + '/question/info/show',
        toggleRecommendStatus: process.env.DOMAIN + '/question/info/toggle/recommend',
        getQuestionSearchProblemList: process.env.DOMAIN + '/question/info/full/page/list',
        copyCountIncrement: process.env.DOMAIN + '/question/info/add/copy/count',
        toggleCollection: process.env.DOMAIN + '/question/info/toggle/collect',
        setBaseAttribute: process.env.DOMAIN + '/product_common/base-attribute/store',
        getInsuranceCategoryMap: process.env.DOMAIN + '/product_common/get-insurance-category-map',
        getBaseAttributeDetail: process.env.DOMAIN + '/product_common/base-attribute/show',
        getProductAnnualDeliveryOptions: process.env.DOMAIN + '/product_common/base-attribute/sypf/attr-list',
        setProductCoefficient: process.env.DOMAIN + '/product_common/base-attribute/sypf/store',
        updateProductCoefficient: process.env.DOMAIN + '/product_common/base-attribute/sypf/update',
        getProductCoefficientList: process.env.DOMAIN + '/product_common/base-attribute/sypf/list',
        getProductCoefficientDetail: process.env.DOMAIN + '/product_common/base-attribute/sypf/show',
        delProductCoefficientItem: process.env.DOMAIN + '/product_common/base-attribute/sypf/delete',
        getSingleChannelList: process.env.DOMAIN + '/product_common/get-sales-platform-map',
        editCPSPromoteInfo: process.env.DOMAIN + '/cps/product/edit_promote_info',
        editAPIPromoteInfo: process.env.DOMAIN + '/product/core/update/promote_info',
        // 获取字段模板
        getProductEvaluationFieldsTpl: process.env.DOMAIN + '/product_evaluation/get_fields_tpl',
        // 计划书产品列表
        getProductEvaluationProposalProductList: process.env.DOMAIN + '/product_evaluation/get_proposal_product_list',
        // 一览表产品列表
        getProductEvaluationProductList: process.env.DOMAIN + '/product_evaluation/product_list',
        // 计划书产品详情 /proposal/product/detail
        // 供应商列表 /supplier/list
        // 一览表相关常量
        getProductEvaluationConstantOptions: process.env.DOMAIN + '/product_evaluation/get_constant_options',
        // 新增产品
        addProductEvaluation: process.env.DOMAIN + '/product_evaluation/add',
        // 计划书详情
        getProposalProductDetail: process.env.DOMAIN + '/product_evaluation/proposal_product_detail',
        // 上下架
        setProductStatus: process.env.DOMAIN + '/product_evaluation/set_product_status',
        // 一览表产品详情
        getProdctEvaluationDetail: process.env.DOMAIN + '/product_evaluation/detail',
        // 一览表编辑产品
        updateProductEvaluation: process.env.DOMAIN + '/product_evaluation/update',
        // 编辑 获取字段模板
        getProductEvaluationCopy: process.env.DOMAIN + '/product_evaluation/copy',
        // 获取一览表费率模版
        getProductRate: process.env.DOMAIN + '/product_evaluation/get_product_rates',
        // ---------继续率产品关联-------------
        // 产品分组列表 (继续率比例关系列表)
        getProductGroupList: process.env.DOMAIN + '/product_group/page_list',
        // 供应商下拉数据
        getSuplierList: process.env.DOMAIN + '/supplier/list',
        // 险种数据
        getInsuranceData: process.env.DOMAIN + '/product/insurance-class',
        // 继续率计算关联产品数据
        getApiProductData: process.env.DOMAIN + '/product/api_cps_products',
        // 创建产品分组
        createProductGroup: process.env.DOMAIN + '/product_group/create',
        // 删除产品分组
        deleteProductGroup: process.env.DOMAIN + '/product_group/delete',
        // 产品分组详情
        getProductGroupDetail: process.env.DOMAIN + '/product_group/detail',
        // 创建单品产品列表
        getApiCpsProducts: process.env.DOMAIN + '/product/api_cps_products',
        // 批量创建分组
        batchProductGroup: process.env.DOMAIN + '/product_group/batch_create',
        // ------------------手续费页--------------------------
        // 编辑/新增方案
        createCommission: process.env.DOMAIN + '/commission_setting/store',
        // 方案列表
        getCommissionList: process.env.DOMAIN + '/commission_setting/page_list',
        // 方案详情
        getCommissionDetail: process.env.DOMAIN + '/commission_setting/detail',
        // 方案属性列表
        getProductAttr: process.env.DOMAIN + '/product_common/base-attribute/sypf/attr-list',
        // 删除方案
        deleteScheme: process.env.DOMAIN + '/commission_setting/delete',
        // 首期手续分清单
        getPolicyList: process.env.DOMAIN + '/commission_setting/get_first_year_service_charge_list',
        // 上传清单
        exportFirstYearCommissionList: process.env.DOMAIN + '/policy/export/first-year-commission',
        //---------------------------------------------------
        // 产品资料 - 分类列表
        getProductDocCategoryList: process.env.DOMAIN + '/product_common/product/docs/list',
        // 产品资料 - 保存分类
        saveProductDocCategory: process.env.DOMAIN + '/product_common/product/docs/save',
        getPreOrderList:  process.env.DOMAIN + '/cps/product/pre-uw/list',
        getPreSelectOptions:  process.env.DOMAIN + '/cps/product/pre-uw/select-options',
        getPreShareLink: process.env.DOMAIN + '/agent/proxy/product/pre-uw-share-link'
    },
    supplier: {
        getGroupList: process.env.DOMAIN + '/supplier/group/page/list',
        addGroup: process.env.DOMAIN + '/supplier/group/store',
        getGroup: process.env.DOMAIN + '/supplier/group/show',
        editGroup: process.env.DOMAIN + '/supplier/group/update',
        getCompanyList: process.env.DOMAIN + '/supplier/company/page/list',
        getGroupSelectList: process.env.DOMAIN + '/supplier/group/list',
        addCompany: process.env.DOMAIN + '/supplier/company/store',
        getCompanyInfo: process.env.DOMAIN + '/supplier/company/show',
        updateCompany: process.env.DOMAIN + '/supplier/company/update',
        getCompanySelectList: process.env.DOMAIN + '/supplier/company/list',
        getSupplierList: process.env.DOMAIN + '/supplier/page/list',
        addSupplier: process.env.DOMAIN + '/supplier/store',
        editSupplier: process.env.DOMAIN + '/supplier/update',
        getSupplierSelectList: process.env.DOMAIN + '/supplier/list',
        delProductEvaluation: process.env.DOMAIN + '/product_evaluation/del',
        delSupplierItem: process.env.DOMAIN + '/supplier/check-delete',
        getSupplierGoods: process.env.DOMAIN + '/supplier/show',
        checkCompanyAlias: process.env.DOMAIN + '/supplier/check/alias',
        // claim
        setClaimInformation: process.env.DOMAIN + '/supplier/company/claim/upload',
        getCompanyClaimInformation: process.env.DOMAIN + '/supplier/company/claim/file/info',
        getClaimChannelList: process.env.DOMAIN + '/supplier/claim/channel/list',
        setClaimRecordSteps: process.env.DOMAIN + '/supplier/claim/record/steps',
        getClaimRecordSteps: process.env.DOMAIN + '/supplier/claim/step/info'
        // getClaimRecordDetail: process.env.DOMAIN + '/supplier/company/claim/info',

        // parseFile: process.env.DOMAIN + '/supplier/company/claim/file/info'
    },
    commission: {
        // cps
        getCpsProductList: process.env.DOMAIN + '/cps/product/list',
        // api
        getProductList: process.env.DOMAIN + '/product/core/list',
        getChannelLists: process.env.DOMAIN + '/insurance/common/insurance/issue/channel/list'
    },
    product: {
        getProductCateLists: process.env.DOMAIN + '/insurance/category/list',
        getProductCateListsByCps: process.env.DOMAIN + '/cps/product/category/list',
        getProductCateListsByCore: process.env.DOMAIN + '/product/core/category/list',
        addProductCateByLevel: process.env.DOMAIN + '/insurance/category/store',
        delProductCateById: process.env.DOMAIN + '/insurance/category/del',
        editProductCateByLevel: process.env.DOMAIN + '/insurance/category/update',
        // 新增编辑素材分类
        addMaterialCategory: process.env.DOMAIN + '/product/cover-material/category/add',
        // 素材分类列表
        getMaterialCategoryList: process.env.DOMAIN + '/product/cover-material/category/list',
        // 新增素材图片
        addMaterialImg: process.env.DOMAIN + '/product/cover-material/cover/add',
        // 素材图片列表
        getMaterialImgList: process.env.DOMAIN + '/product/cover-material/cover-page-list',
        // 获取素材关联的产品列表
        getMaterialRelativeProductList: process.env.DOMAIN + '/product/cover-material/relative-products'
    },

    proposal: {
        setProposalStatus: process.env.DOMAIN + '/proposal/product/set-status',
        getProposalGuaranteeLists: process.env.DOMAIN + '/proposal/guarantee-responsibility/list',
        getProposalGuaranteeList: process.env.DOMAIN + '/proposal/guarantee-responsibility/list-with-page',
        postProposalGuaranteeDetail: process.env.DOMAIN + '/proposal/guarantee-responsibility/update',
        getProposalGuaranteeDetail: process.env.DOMAIN + '/proposal/guarantee-responsibility/detail',
        addProposalGuaranteeDetail: process.env.DOMAIN + '/proposal/guarantee-responsibility/add',
        delProposalGuaranteeDetail: process.env.DOMAIN + '/proposal/guarantee-responsibility/delete',

        getProposalProductList: process.env.DOMAIN + '/proposal/product/list-with-page',
        getProductInsuranceClassList: process.env.DOMAIN + '/proposal/product/insurance-class-list',
        getProposalCategoryInfo: process.env.DOMAIN + '/proposal/product/detail',
        addProposalProduct: process.env.DOMAIN + '/proposal/product/add',
        updateProposalProduct: process.env.DOMAIN + '/proposal/product/update',
        importFromExcel: process.env.DOMAIN + '/proposal/product/rate/import-from-excel',
        saveRate: process.env.DOMAIN + '/proposal/product/rate/save',
        getRateInfo: process.env.DOMAIN + '/proposal/product/rate/detail',
        copyProposalProduct: process.env.DOMAIN + '/proposal/product/copy',
        // 计划书模板
        getProposalTemplatePageList: process.env.DOMAIN + '/proposal/family-analysis-template/template-page-list',
        getProposalTagList: process.env.DOMAIN + '/proposal/family-analysis-template/group-list',
        addProposalFamilyTag: process.env.DOMAIN + '/proposal/family-analysis-template/add-group',
        editProposalFamilyTag: process.env.DOMAIN + '/proposal/family-analysis-template/edit-group',
        addProposalTemplate: process.env.DOMAIN + '/proposal/family-analysis-template/add',
        deleteProposalFamilyTag: process.env.DOMAIN + '/proposal/family-analysis-template/delete-group',
        changeStatusProposalTemplate: process.env.DOMAIN + '/proposal/family-analysis-template/status-change',
        getProposalTemplateDetail: process.env.DOMAIN + '/proposal/family-analysis-template/detail',
        editProposalTemplate: process.env.DOMAIN + '/proposal/family-analysis-template/edit',
        saveClassOneDisease: process.env.DOMAIN + '/product/disease/store-one-disease-series',
        // 获取储蓄产品管理列表
        getSavingsList: process.env.DOMAIN + '/proposal/deposit-product/list-with-page',

        // 更新列表上下架状态
        updateSavingStatus: process.env.DOMAIN + '/proposal/deposit-product/set-status',

        // 获取保险公司列表
        insuranceList: process.env.DOMAIN + '/proposal/deposit-product/insurance-type',

        // 添加储蓄产品列表
        addSavings: process.env.DOMAIN + '/proposal/deposit-product/create-product',

        // 储蓄产品列表详情
        savingsDetail: process.env.DOMAIN + '/proposal/deposit-product/detail',

        // 储蓄产品列表详情编辑更新
        updateSavingsDetail: process.env.DOMAIN + '/proposal/deposit-product/update-product',

        // 获取产品费率管理详情
        rateManagerDetail: process.env.DOMAIN + '/proposal/deposit-product/get-product-rate',

        // 保存费率信息
        saveRateInfo: process.env.DOMAIN + '/proposal/deposit-product/product-rate-save',

        // 保存现价信息
        saveCashInfo: process.env.DOMAIN + '/proposal/deposit-product/product-cash-save',

        // 理财规划设置信息
        financialInfo: process.env.DOMAIN + '/financial_proposal/all_setting_overview',

        // 市场环境信息
        financialMarketInfo: process.env.DOMAIN + '/financial_proposal/market_environment',

        // 保存市场环境信息
        saveFinancialMarketInfo: process.env.DOMAIN + '/financial_proposal/save_market_environment',

        // 社平工资信息
        financialWageAvgInfo: process.env.DOMAIN + '/financial_proposal/wage_avg_tree',

        // 新增城市的社平工资配置
        saveFinancialWageAvgInfo: process.env.DOMAIN + '/financial_proposal/add_social_average_wage',
        // 编辑社平工资
        editFinancialWageAvgInfo: process.env.DOMAIN + '/financial_proposal/edit_social_average_wage',
        // 国家/地区经济信息
        financialRegionalEconomyInfo: process.env.DOMAIN + '/financial_proposal/region_economy',

        // 新增国家/地区经济信息
        addFinancialRegionalEconomyInfo: process.env.DOMAIN + '/financial_proposal/add_region_economy',

        // 编辑国家/地区经济信息
        editFinancialRegionalEconomyInfo: process.env.DOMAIN + '/financial_proposal/edit_region_economy',

        // 教育费用信息
        financialEduExpensesInfo: process.env.DOMAIN + '/financial_proposal/education_expense',

        // 新增教育经费
        addFinancialEduExpensesInfo: process.env.DOMAIN + '/financial_proposal/add_education_expense',

        // 编辑教育费用信息
        editFinancialEduExpensesInfo: process.env.DOMAIN + '/financial_proposal/edit_education_expense',
        // 病种明细管理
        getDiseaseList: process.env.DOMAIN + '/product/disease/page-list',
        cancelBindProduct: process.env.DOMAIN + '/product/disease/cancel-bind-product',
        bindProduct: process.env.DOMAIN + '/product/disease/bind-product',
        getTemplateDetail: process.env.DOMAIN + '/product/disease/template-detail',
        updateTempName: process.env.DOMAIN + '/product/disease/update-template-name',
        getDiseaseBindInsuranceList: process.env.DOMAIN + '/product/disease/get-disease-bind-insurance-list',
        deleteOneDiseaseSeries: process.env.DOMAIN + '/product/disease/delete-one-disease-series',
        deleteDiseaseTemplate: process.env.DOMAIN + '/product/disease/delete-template',
        diseaseUpload: process.env.DOMAIN + '/product/disease/upload',
        getOneLevelDisease: process.env.DOMAIN + '/proposal/product/rate/get-one-level-disease'
    },
    refund: {
        getCanRefundList: process.env.DOMAIN + '/order/refund/can-refund-list',
        getRefundedList: process.env.DOMAIN + '/order/refund/refund-list',
        getRefundDetail: process.env.DOMAIN + '/order/refund/refund-detail',
        fetchSureRefund: process.env.DOMAIN + '/order/refund/refund'
    },
    serviceCharge: {
        getBaseProgramme: process.env.DOMAIN + '/commission/first/page/list',
        getProductList: process.env.DOMAIN + '/product_common/product/list',
        getInsuranceList: process.env.DOMAIN + '/product_common/insurance/list',
        getProgrammeDetail: process.env.DOMAIN + '/commission/first/detail',
        addProgramme: process.env.DOMAIN + '/commission/first/store',
        editProgramme: process.env.DOMAIN + '/commission/first/update',
        addCommissionContinued: process.env.DOMAIN + '/commission/continued/store',
        getCommissionContinuedList: process.env.DOMAIN + '/commission/continued/page/list',
        getCommissionContinuedDetail: process.env.DOMAIN + '/commission/continued/detail',
        editCommissionContinueDetail: process.env.DOMAIN + '/commission/continued/update'
    },
    CpsApiPoster: {
        upload: process.env.DOMAIN + '/product_common/product/poster/upload',
        list: process.env.DOMAIN + '/product_common/product/poster/list',
        remove: process.env.DOMAIN + '/product_common/product/poster/del'
    },
    insurancePolicy: {
        getInsurancePolicyList: process.env.DOMAIN + '/policy/get/page-list',
        uploadInsurancePolicyFile: process.env.DOMAIN + '/policy/import/policy',
        editSalesPlatform: process.env.DOMAIN + '/policy/change/agent-platform',
        exportFile: process.env.DOMAIN + '/policy/export/policy',
        getUnmatchedProduct: process.env.DOMAIN + '/product/not-clear-products',
        getSalesPlatforms: process.env.DOMAIN + '/cps/product/import/sales-platforms'
    },
    renewal: {
        getRenewalList: process.env.DOMAIN + '/policy/renewal/renewal-log-list',
        getRenewalUploadLogList: process.env.DOMAIN + '/policy/renewal/renewal-upload-log-list',
        getRenewalDetail: process.env.DOMAIN + '/policy/renewal/upload-process-detail',
        uploadRenewalExcel: process.env.DOMAIN + '/policy/renewal/upload-renewal-excel',
        getExcelFailLogList: process.env.DOMAIN + '/policy/renewal/excel-failed-log',
        getSelectOptions: process.env.DOMAIN + '/policy/renewal/form-select-options',
        excelFile: process.env.DOMAIN + '/policy/renewal/export-renewal-log-list',
        updateRenewalStage: process.env.DOMAIN + '/policy/renewal/update-renewal-stage',
        getRenewalInfo: process.env.DOMAIN + '/policy/renewal/detail'
    },
    policyRutler: {
        manpowerList: process.env.DOMAIN + '/policy/manpower/list/page',
        manpowerLechengList: process.env.DOMAIN + '/policy/lecheng/manpower/list/page',
        manpowerLechengListMW: process.env.DOMAIN + '/policy/lecheng/manpower/list/page/secret',
        list: process.env.DOMAIN + '/policy/get/page-list',
        supplierList: process.env.DOMAIN + '/supplier/list',
        apiCpsProducts: process.env.DOMAIN + '/policy/api-and-cps-products',
        salesPlatforms: process.env.DOMAIN + '/product_common/get-sales-platform-map',
        baseInfo: process.env.DOMAIN + '/policy/detail/base',
        customerInfo: process.env.DOMAIN + '/policy/detail/policy_holder',
        insuareInfo: process.env.DOMAIN + '/policy/detail/insurances',
        payInfo: process.env.DOMAIN + '/policy/detail/payment',
        salesInfo: process.env.DOMAIN + '/policy/detail/sales',
        visitInfo: process.env.DOMAIN + '/policy/detail/visit',
        relationInfo: process.env.DOMAIN + '/policy/detail/children',
        renewalInfo: process.env.DOMAIN + '/policy/detail/renewal',
        redownLoadUrl: process.env.DOMAIN + '/policy/detail/download/policy',
        manPower: process.env.DOMAIN + '/policy/detail/manpower',
        manPowerDetail: process.env.DOMAIN + '/policy/manpower/detail',
        detail: '',
        exportFile: process.env.DOMAIN + '/policy/list/export',
        downloadOrder: '',
        gainAgain: '',
        replenish: process.env.DOMAIN + '/policy/import/completion-policy', // 保单补录
        replenishInfo: process.env.DOMAIN + '/policy/detail/manual/supplement-info', // 人工补录
        replenishEdit: process.env.DOMAIN + '/policy/detail/manual/supplement-info/edit', // 人工补录编辑
        replenishAdd: process.env.DOMAIN + '/policy/detail/manual/supplement-info/add', // 人工补录新增
        replenishDelete: process.env.DOMAIN + '/policy/detail/manual/supplement-info/delete', // 人工补录删除
        refreshLastUpdateTime: process.env.DOMAIN + '/policy/refresh-last-update-time', // 更新最后更新时间
        updateGuaranteePeriod: process.env.DOMAIN + '/policy/guarantee-period/edit', // 编辑保障期间
        updatePaymentPeriod: process.env.DOMAIN + '/policy/payment-period/edit', // 编辑缴费期间
        updateFrequency: process.env.DOMAIN + '/policy/payment-period-frequency/edit', // 编辑频次
        baseInfoEdit: process.env.DOMAIN + '/policy/detail/manual/base-info/edit', // 修改保单基本信息
        visitInfoEdit: process.env.DOMAIN + '/policy/detail/manual/visit-info/edit', // 修改保单回访信息
        getServiceFee: process.env.DOMAIN + '/policy/detail/cfyf-service-fee-setting',
        doubleRecordList: process.env.DOMAIN + '/policy/detail/double-record',
        policyPreserveList: process.env.DOMAIN + '/policy/detail/policy-preserve',
    },
    website: {
        bannerList: process.env.DOMAIN + '/website/banner/list_with_page', // 获取官网banner列表
        bannerDetail: process.env.DOMAIN + '/website/banner/detail', // 获取banner详情
        addBanner: process.env.DOMAIN + '/website/banner/create_banner', // 添加banner
        editBanner: process.env.DOMAIN + '/website/banner/update_banner', // 添加banner
        setBannerStatus: process.env.DOMAIN + '/website/banner/is_enable', // 添加banner
        websiteCateList: process.env.DOMAIN + '/website/product_category/list_with_page', // 获取官网分类列表
        addCate: process.env.DOMAIN + '/website/product_category/create', // 官网分类添加
        websiteCateDetail: process.env.DOMAIN + '/website/product_category/detail', // 官网分类详情
        editCate: process.env.DOMAIN + '/website/product_category/update', // 官网分类编辑
        setCateStatus: process.env.DOMAIN + '/website/product_category/is_enable', // 添加banner
        getCpsInfo: process.env.DOMAIN + '/cps/branch/select_list', // 获取cps分支产品信息
        cateList: process.env.DOMAIN + '/website/product_category/get_show_select',
        releaseProduct: process.env.DOMAIN + '/website/product/save_product', // cps、api产品发布商品
        releaseProductDetail: process.env.DOMAIN + '/website/product/detail', // 获取官网设置详情
        productDisplayConfigs: process.env.DOMAIN + '/product/display-rule/get-constants', // 获取设置产品显示页面对应的配置
        productConfigRule: process.env.DOMAIN + '/product/display-rule/get-display-channel-setting', // 获取某个显示渠道的配置规则
        // 设置是否开始某个显示规则
        setDisplayRuleOpenOrClose: process.env.DOMAIN + '/product/display-rule/set-enable-status',
        // 设置渠道属性
        setChannelTag: process.env.DOMAIN + '/product/display-rule/set-sales-platform-rule',
        // 官网设置保存
        saveWebsiteSetting: process.env.DOMAIN + '/website/product/save-material',
        // 获取官网设置信息
        getWebsiteSettingInfo: process.env.DOMAIN + '/website/product/material'
    },
    startClass: {
        setCurseSort: process.env.DOMAIN + '/course/sort-course-group', // 设置分组排序
        bannerList: process.env.DOMAIN + '/course/get-course-banner-lists', // 获取banner列表
        groupList: process.env.DOMAIN + '/course/get-course-group-lists', // 获取分组列表
        addCourse: process.env.DOMAIN + '/course/add-course', // 添加课程
        addCourseBanner: process.env.DOMAIN + '/course/add-course-banner', // 添加课程banner
        addCourseGroup: process.env.DOMAIN + '/course/add-course-group', // 添加课程分组
        editCourse: process.env.DOMAIN + '/course/edit-course', // 添加课程分组
        editCourseBanner: process.env.DOMAIN + '/course/edit-course-banner', // 编辑课程banner
        editCourseGroup: process.env.DOMAIN + '/course/edit-course-group', // 编辑课程分组
        courseList: process.env.DOMAIN + '/course/get-course-lists', // 编辑课程分组
        delCourse: process.env.DOMAIN + '/course/del-course', // 删除课程
        delCourseBanner: process.env.DOMAIN + '/course/del-course-banner', // 删除课程banner
        delCourseGroup: process.env.DOMAIN + '/course/del-course-group', // 删除课程分组
        batchDelCourse: process.env.DOMAIN + '/course/batch-del-course', // 批量删除课程
        changeOnSale: process.env.DOMAIN + '/course/is-on-sale-course', // 上下架课程
        changeRecommend: process.env.DOMAIN + '/course/is-recommend-course', // 推荐课程
        batchShelfCourse: process.env.DOMAIN + '/course/batch-is-on-sale-course', // 批量上下架课程
        applicableAge: process.env.DOMAIN + '/course/applicable-age', // 批量上下架课程
        courseAnalysis: process.env.DOMAIN + '/course/analysis', // 运营分析
        courseAnalysisStatistics: process.env.DOMAIN + '/course/analysis-statistics', // 运营分析
        analysisStatistics: process.env.DOMAIN + '/course/analysis-statistics', // 运营分析
        analysisStatisticsInfo: process.env.DOMAIN + '/course/analysis-statistics-info', // 运营分析
        analysisInfo: process.env.DOMAIN + '/course/analysis-info', // 运营分析
        questionnaireList: process.env.DOMAIN + '/questionnaire/index', // 问卷列表
        questionnaireDetail: process.env.DOMAIN + '/questionnaire/details', // 问卷数据分析
        questionnaireStatistics: process.env.DOMAIN + '/questionnaire/statistics', // 问卷详情
        questionnaireAnswerRecord: process.env.DOMAIN + '/questionnaire/answer-record', // 问卷答题记录
        questionnaireAnswerDetails: process.env.DOMAIN + '/questionnaire/answer-details', // 问卷答题详情
        getPlayLog: process.env.DOMAIN + '/course/get-play-log', // 课程播放明细
        getAnalysisStatistics: process.env.DOMAIN + '/course/analysis-statistics-info', // 课程播放明细
        getCourseDetail: process.env.DOMAIN + '/course/details', // 课程播放明细
        userInternal: process.env.DOMAIN + '/user/internal', // 内部人员列表
        getInternalLink: process.env.DOMAIN + '/user/internal-user-link', // 获取邀请二维码
        getChildBehaviorResult: process.env.DOMAIN + '/questionnaire/child-behavior/answer-details', // 儿童问卷行为量表答题详情
        getChildBehaviorEcho: process.env.DOMAIN + '/questionnaire/child-behavior/echo', // 儿童问卷行为量表答题详情
    },
    startClassApplet: {
        bannerList: process.env.DOMAIN + '/kkb/banner/get-lists', // 获取banner列表
        addBanner: process.env.DOMAIN + '/kkb/banner/add-banner', // 添加banner
        editBanner: process.env.DOMAIN + '/kkb/banner/edit-banner', // 编辑banner
        upOrDownBanner: process.env.DOMAIN + '/kkb/banner/up-or-down', // 编辑banner
        addFirstCategory: process.env.DOMAIN + '/kkb/course/category/add', // 添加一级类目
        firstCategoryList: process.env.DOMAIN + '/kkb/course/category/get-list', // 一级类目列表
        editFirstCategory: process.env.DOMAIN + '/kkb/course/category/edit', // 编辑一级类目
        secondCategoryList: process.env.DOMAIN + '/kkb/course/category/sub/get-list', // 二级类目列表
        addSecondCategory: process.env.DOMAIN + '/kkb/course/category/sub/add', // 添加二级类目
        editSecondCategory: process.env.DOMAIN + '/kkb/course/category/sub/edit', // 编辑二级类目
        getWholeEnableList: process.env.DOMAIN + '/kkb/course/category/get-whole-enable-list', // 获取完整启用分类
        getListByCategory: process.env.DOMAIN + '/kkb/course/get-list-by-category', // 根据二级分类获取课程列表
        getCourseDetail: process.env.DOMAIN + '/kkb/course/get-details', // 根据二级分类获取课程列表
        addCourse: process.env.DOMAIN + '/kkb/course/add', // 添加课程
        editCourse: process.env.DOMAIN + '/kkb/course/edit', // 编辑课程
        deleteCourse: process.env.DOMAIN + '/kkb/course/del', // 删除课程
        upOrDownCourse: process.env.DOMAIN + '/kkb/course/up-or-down', // 上架/下架课程
        batchUpOrDownCourse: process.env.DOMAIN + '/kkb/course/batch-up-or-down', // 批量上架/下架课程
        recommendCourse: process.env.DOMAIN + '/kkb/course/recommend', // 批量上架/下架课程
        getRecommendList: process.env.DOMAIN + '/kkb/course/recommend-list', // 获取推荐课程列表
        setRecommendSort: process.env.DOMAIN + '/kkb/course/set-sort', // 获取推荐课程列表
        questionList: process.env.DOMAIN + '/kkb/questionnaire/index', // 问卷列表
        questionDetail: process.env.DOMAIN + '/kkb/questionnaire/details', // 问卷详情
        questionStatistics: process.env.DOMAIN + '/kkb/questionnaire/statistics', // 数据分析
        answerRecord: process.env.DOMAIN + '/kkb/questionnaire/answer-record', // 答题记录
        answerDetail: process.env.DOMAIN + '/kkb/questionnaire/answer-details', // 答题详情
        internalUserList: process.env.DOMAIN + '/kkb/user/internal-user', // 获取内部人员列表
        getInternalQrCode: process.env.DOMAIN + '/kkb/user/get-internal-qrcode', // 获取邀请内部人员小程序码
        getCourseStatistics: process.env.DOMAIN + '/kkb/statistics/get-course-statistics', // 获取课程统计数据
        getCourseStatisticsSum: process.env.DOMAIN + '/kkb/statistics/get-course-statistics-sum', // 获取课程统计数据汇总
        getCourseVideoStatistics: process.env.DOMAIN + '/kkb/statistics/get-course-video-statistics', // 获取课程视频统计数据
        getCourseVideoStatisticsSum: process.env.DOMAIN + '/kkb/statistics/get-course-video-statistics-sum', // 获取课程视频统计数据汇总
        getCoursePlayLog: process.env.DOMAIN + '/kkb/statistics/get-course-play-log', // 获取课程视频统计数据汇总
        getCoursePlayStatistics: process.env.DOMAIN + '/kkb/statistics/get-course-play-statistics', // 获取课程观看统计
        getCourseVideoPlayLog: process.env.DOMAIN + '/kkb/statistics/get-course-video-play-log', // 获取课程视频观看明细
        getCourseVideoPlayStatistics: process.env.DOMAIN + '/kkb/statistics/get-course-video-play-statistics', // 获取课程视频观看统计
        exportCoursePlayLog: process.env.DOMAIN + '/kkb/statistics/export-course-play-log', // 导出课程播放明细
        exportCourseVideoPlayLog: process.env.DOMAIN + '/kkb/statistics/export-course-video-play-log', // 导出课程播放明细
        exportCourseStatistics: process.env.DOMAIN + '/kkb/statistics/export-course-statistics', // 导出课程统计数据
        exportCourseVideoStatistics: process.env.DOMAIN + '/kkb/statistics/export-course-video-statistics', // 导出课程视频统计数据
        getCourseResourceList: process.env.DOMAIN + '/kkb/course/get-course-resource-list', // 资源库列表
        classifyCourseResource: process.env.DOMAIN + '/kkb/course/classify-course-resource', // 分类课程资源
        batchClassifyCourseResource: process.env.DOMAIN + '/kkb/course/batch-classify-course-resource', // 分类课程资源
        getLimitDurationLog: process.env.DOMAIN + '/kkb/course/video/limit-duratin-log', // 获取课程视频限制时长修改记录
        editCoverPicture: process.env.DOMAIN + '/kkb/questionnaire/edit-cover-picture', // 问卷编辑分享图
        secretSignalQueriedList: process.env.DOMAIN + '/kkb/secret-signal/queried/list', //获取暗号数据列表    
        secretSignalQueriedDetails: process.env.DOMAIN + '/kkb/secret-signal/queried/details', //获取单个暗号数据详情 
        secretSignalList: process.env.DOMAIN + '/kkb/secret-signal/list', //获取暗号库分页列表
        secretSignalChangeStatus: process.env.DOMAIN + '/kkb/secret-signal/change-status', //变更暗号状态
        secretSignalUploadLogList: process.env.DOMAIN + '/kkb/secret-signal/upload-log/list', //暗号上传表格记录分页列表
        secretSignalUpload: process.env.DOMAIN + '/kkb/secret-signal/upload', //上传暗号文件
        getCouponsPageList: process.env.DOMAIN + '/kkb/coupons/get-page-list', // 获取优惠券列表
        addCoupons: process.env.DOMAIN + '/kkb/coupons/add', // 添加优惠券
        editCoupons: process.env.DOMAIN + '/kkb/coupons/edit', // 编辑优惠券
        getCouponsDetails: process.env.DOMAIN + '/kkb/coupons/get-details', // 获取优惠券详情
        createExchangeCode: process.env.DOMAIN + '/kkb/coupons/create-exchange-code', // 生成兑换码
        getExchangeList: process.env.DOMAIN + '/kkb/coupons/get-exchange-list', // 获取优惠券兑换记录
        exportExchangeCode: process.env.DOMAIN + '/kkb/coupons/export-exchange-code', // 导出兑换码
        getWatchSettings: process.env.DOMAIN + '/kkb/settings/get-watch-settings', // 获取小程序观看设置
        saveWatchSettings: process.env.DOMAIN + '/kkb/settings/save-watch-settings', // 设置小程序观看设置
        getExchangePageQrcode: process.env.DOMAIN + '/kkb/coupons/get-exchange-page-qrcode', // 获取付费链接小程序码

    },
    common: {
        insurance_info_list: process.env.DOMAIN + '/product/get-insurance-info-list', // 险种信息列表
        insurance_alias_list_store: process.env.DOMAIN + '/product/insurance-alias-list/store', // /product/insurance_alias_list/store
        alias_list: process.env.DOMAIN + '/product/get-insurance-alias-list', // 别名选项
        commission_verify_get_info: process.env.DOMAIN + '/commission_setting/verify/get-info', // 获取审核信息
        commission_verify_store: process.env.DOMAIN + '/commission_setting/verify/store', // 保存审核信息
        cps_branch_list: process.env.DOMAIN + '/cps/branch/list', // 产品分支-分支列表 GET
        cps_branch_store: process.env.DOMAIN + '/cps/branch/store', // 分支产品-新增 POST
        cps_branch_show: process.env.DOMAIN + '/cps/branch/show', // 分支产品-详情-单个 GET
        cps_branch_delete: process.env.DOMAIN + '/cps/branch/delete', // 分支产品-删除-单个 GET
        simulate_login: process.env.DOMAIN + '/auth/faced/simulate', // 模拟登录获取用户信息
        get_product_connection_plate: process.env.DOMAIN + '/product-connection/product/show', // 获取产品关联七大板块接口
        productConnectManual: process.env.DOMAIN + '/product-connection/manual', // cps或api产品关联商品
        cancelProductConnect: process.env.DOMAIN + '/product-connection/cancel', // cps或api产品取消关联商品
        getAdminPasswordStatus: process.env.DOMAIN + '/admin/get_password_expire_status', // 获取密码状态
        getAllProductList: process.env.DOMAIN + '/product-connection/product/list', // 获取cps和api产品集合
        getProvinceCityData: process.env.DOMAIN + '/region/province-city-tree' // 省份-城市树数据
    }
}

export default API_PATH



// WEBPACK FOOTER //
// ./src/config/api.js